export const validateEmail = email => {
    const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return regexp.test(email);
};

export const validatePassword = password => {
    // eslint-disable-next-line no-useless-escape
    const regexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&\-_='"~`[\]{}+^():;,.|\/\\<>#]{8,}$/;
    return regexp.test(password);
};

export const validatePasswordContainsLowerCase = password => {
    const regexp = /(?=.*[a-z])/;
    return regexp.test(password);
};

export const validatePasswordContainsUpperCase = password => {
    const regexp = /(?=.*[A-Z])/;
    return regexp.test(password);
};

export const validatePasswordContainsDigits = password => {
    const regexp = /(?=.*[0-9])/;
    return regexp.test(password);
};

export const validatePasswordNoWhitespace = password => {
    const regexp = /(?=.*[\s])/;
    return !regexp.test(password);
};
